export default __webpack_public_path__ + "static/media/Service_pic2.3b6563b1.png";